// extracted by mini-css-extract-plugin
export var subscribe = "Subscribe-module--subscribe--rdjVR";
export var contentCenter = "Subscribe-module--contentCenter--TOuY+";
export var formContainer = "Subscribe-module--formContainer--T39+I";
export var inputBox = "Subscribe-module--inputBox--03EnC";
export var customGoogleAuthButton = "Subscribe-module--customGoogleAuthButton--o87AP";
export var subscribeButton = "Subscribe-module--subscribeButton--Mvwul";
export var formItem = "Subscribe-module--formItem--SA1ap";